import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import AuthService from "../../services/AuthService";
import { getQueryParam } from '../../utils/queryParams';

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            logged: false,
            login: true,
            redirect: this.props.location.state && this.props.location.state.from ? this.props.location.state.from : '/'
        }
    }

    async componentDidMount() {
        this.setState({login: true});
        const loginResult = await AuthService.login();
        let logged = false;
        if (loginResult) {
            logged = true;
        }
        setTimeout(() => {
            this.setState({logged, login: false});
            this.props.setIsAuthenticated(logged);
        }, 2000);
    }

    render() {
        if (this.state.login) {
            return (<div>Login...</div>);
        }
        else {
            if (this.state.logged) {

                if(getQueryParam(this.props.location.search, 'updateContactData') === 'true'){

                    const queryString = getQueryParam(this.props.location.search, 'showMessage') === 'true' ? '?showMessage=true' : '';

                    return <Redirect to={`/contacto-facturacion${queryString}`}/>    
                }
                return <Redirect to={this.state.redirect}/>
            }
            else {
                return (<div>
                    Redirecting...
                    <Redirect to={'external-login'}/>
                </div>);
            }
        }
    }
}

export default Login;
